<template lang="pug">
  .logsPage
    h5().bolder Sync Logs
    table.w-100.mt-5.table.table-striped
        thead
            th Id <br>
                input(type="text", v-model="params.id")
            th Description  <br>
                input(type="text" v-model="params.description")
            th Export<br> CSV
        tbody
            tr(v-for="log in filteredLogs")
                td {{log.id}}
                td {{log.description}}
                td 
                    button.btn.btn-primary Download file
</template>

<script>
// import {SyncUseCaseSlim, SyncEdit} from './SyncComponents'
// import CREATE_UPDATE_SYNC from '../../graphql/CreateUpdateSync.gql'
// import {APIManager} from '../../helpers'
import _ from 'lodash'
export default {
  name: 'LogsPage',
  props:{
  },
  components: {
  },
  data() {
    return {
        error: null,
        loading: true,
        params: {
            id: "",
            description: ""
        },
        logs: [{
            id: "1",
            description: "ciao"
        },{
            id: "2",
            description: "dsf"
        }]
    }
  },
  mounted() {
  },
  methods: {
      
  },
  computed: {
      filteredLogs: function(){
          let result = _.cloneDeep(this.logs) ?? [];
          if(!this.logs) return result;

          this.logs.forEach((log) => {
              if(this.params.id != "" && !log.id.includes(this.params.id)) result.pop(log);
              if(this.params.description != "" && !log.description.includes(this.params.description)) result.pop(log);
          })
          return result;
      }
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url('@/less/global.less');
</style>
